import { createSlice } from '@reduxjs/toolkit';

import type { Flags } from './type';

export type { Flags } from './type';

export const flagsSlice = createSlice({
    name: '@FLAGS',
    initialState: {} as Flags,
    reducers: {},
});

export const flagsReducer = flagsSlice.reducer;
